import util from '@tencent/vft-common/util'
import env from '@tencent/vft-common/env'

export function getChannel (app, from) {
  let channel = 0
  if (app === 'wechat') {
    if (from === 'friend') {
      channel = 16
    } else if (from === 'timeline') {
      channel = 8
    } else if (from === 'weibo') {
      channel = 1
    } else if (from === 'qq') {
      channel = 64
    } else if (from === 'qzone') {
      channel = 2
    }
  } else if (app === 'qq') {
    if (from === 0) { // QQ好友
      channel = 64
    } else if (from === 1) { // QQ空间
      channel = 2
    } else if (from === 2) { // 微信好友
      channel = 16
    } else if (from === 3) { // 微信朋友圈
      channel = 8
    }
  }

  if (!app) {
    if (env.isWechat) {
      from = util.getUrlParam('from')
      if (from === 'timeline') {
        channel = 8
      } else {
        channel = 16
      }
    } else if (/Weibo\//.test(navigator.userAgent)) {
      channel = 4
    } else if (env.isMqq) {
      channel = 64
    } else if (/ Qzone\//.test(navigator.userAgent)) {
      channel = 2
    }
  }
  return channel
}
